export var CheckoutType;
(function (CheckoutType) {
    CheckoutType[CheckoutType["UNKNOWN_CHECKOUT_TYPE"] = 0] = "UNKNOWN_CHECKOUT_TYPE";
    CheckoutType[CheckoutType["EVENTS_APP"] = 1] = "EVENTS_APP";
    CheckoutType[CheckoutType["ECOMM_PLATFORM"] = 2] = "ECOMM_PLATFORM";
})(CheckoutType || (CheckoutType = {}));
